import Stack from '@mui/material/Stack';
import { FormattedMessage } from 'react-intl';

import HeaderTextComponent from '../../../common/headerTextComponent';

import { FinalReportTemplateBuilder } from '~/pages/customer/settings/final-report/template-builder/route';

const FinalReportHeader = () => (
  <Stack direction='row' justifyContent='space-between' alignItems='center'>
    <HeaderTextComponent variant='h1'>
      <FormattedMessage defaultMessage='Final Report Templates' />
    </HeaderTextComponent>
    <FinalReportTemplateBuilder />
  </Stack>
);

export default FinalReportHeader;
